import * as React from "react";
import { IconLogoMark } from "./Icons";

/*===========================================================================
  Loading
/*======================================================================== */

interface LoadingProps {
    empty?: boolean,
    height?: number
    message?: string,
    modifierClass?: string,
    width?: number,
}

const Loading = (props: LoadingProps) => {
    const message = props.empty ? "" : !!props.message ? props.message : "loading";
    const width = props.width || 64;
    const height = props.height || 64;
    return (
        <div id={"loading-overlay"} className={`c-loading ${props.modifierClass}`}>
            <IconLogoMark width={width} height={height} />
            <div className="c-loading__message">{message}</div>
        </div>
    );
}

export default Loading;
